import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import blockService from './blockService';

const initialState = {
  changeBLock: '',
  isChangeBLockError: false,
  isChangeBLockSuccess: false,
  isChangeBLockLoading: false,
  isChangeBLockErrorMsg: '',
};

export const creatingChangeBLock = createAsyncThunk(
  'changeBLock/creatingChangeBLock',

  async (headingkData, thunkAPI) => {
    try {
      const response = await blockService.changeStatusBlock(headingkData);
      return response;
    } catch (error) {
      const isChangeBLockErrorMsg =
        (error.response && error.response.data && error.response.data.isChangeBLockErrorMsg) ||
        error.isChangeBLockErrorMsg ||
        error.toString();
      return thunkAPI.rejectWithValue(isChangeBLockErrorMsg);
    }
  }
);


export const changeSlice = createSlice({
  name: 'changeBLock',
  initialState,
  reducers: {
    resetUser: (state) => {
      state.isChangeBLockLoading = false;
      state.isChangeBLockSuccess = false;
      state.isChangeBLockError = false;
      state.isChangeBLockErrorMsg = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(creatingChangeBLock.pending, (state) => {
        state.isChangeBLockLoading = true;
      })
      .addCase(creatingChangeBLock.fulfilled, (state, action) => {
        state.isChangeBLockLoading = false;
        state.isChangeBLockSuccess = true;
        state.changeBLock = action.payload;
      })
      .addCase(creatingChangeBLock.rejected, (state, action) => {
        state.isChangeBLockLoading = false;
        state.isChangeBLockError = true;
        state.isChangeBLockErrorMsg = action.payload; // error from catch will come here via action.payload and update ischangeBLockErrorMsg
      });
  },
});

export const { resetUser } = changeSlice.actions;
export default changeSlice.reducer;
